<template>
  <div
    style="width: 100%"
    @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
    @mouseleave="handleShowOperationBtn(false)"
  >
    <div class="top-nav-container">
      <div
        :class="{
          'top-nav   top-nav-fixed': props.componentData.fromType === 3,
          'top-nav   top-nav-absolute': props.componentData.fromType !== 3,
        }"
      >
        <div class="top-nav-web">
          <div
            class="top-nav-login-search"
            :style="{
              'background-color': configDataForm.topBackgroundColor,
            }"
          >
            <img
              :src="configDataForm.topImageFullUrl || noUpload"
              alt="顶部图片"
              loading="lazy"
            />
            <div class="search-link">
              <a
                target="_blank"
                :href="configDataForm.loginLinkUrl"
                class="login"
                :style="{
                  color: configDataForm.loginTextColor + ' !important',
                }"
                v-text="configDataForm.loginTextTitle"
              >
              </a>
              <a
                class="search"
                :href="handleSearchHref(configDataForm.searchLinkUrl)"
                :style="{
                  color: configDataForm.searchTextColor + ' !important',
                }"
                v-text="configDataForm.searchTextTitle"
              >
              </a>
            </div>
          </div>

          <div
            :class="{
              'top-nav-menu-container': !isDarkLogoStyle && !isBackTopFlag,
              'top-nav-menu-container-deep': isDarkLogoStyle,
              'top-nav-menu-container-deep-home': isBackTopFlag,
            }"
            @mouseenter="handleShowOperationBtn(props.showEditContentButton)"
            @mouseleave="handleShowOperationBtn(false)"
          >
            <div class="top-nav-menu-logo">
              <a :href="indexHrefUrl"
                ><img
                  :src="leftLogoImageUrl || noUpload"
                  alt="Logo"
                  loading="lazy"
              /></a>
            </div>
            <div class="top-nav-menu-list">
              <span class="menu-close" @click="handleShowMoreMenu"> </span>
              <span
                v-for="item in columnList"
                :key="item.id"
                :class="{
                  active: item.id == activeIndex,
                  'top-nav-menu-list-item': true,
                }"
              >
                <a
                  v-if="item.children && item.children.length > 0"
                  :href="item.children[0].data.hrefURL"
                >
                  {{ item.label }}
                </a>
                <a v-else-if="item.data" :href="item.data.hrefURL">
                  {{ item.label }}
                </a>
                <div
                  v-if="item.children && item.children.length > 0"
                  class="sub-menu"
                >
                  <ul class="sub-nav">
                    <li></li>
                    <li
                      v-for="subitem in item.children"
                      :key="'su-el' + item.id + '-' + subitem.id"
                    >
                      <a v-if="subitem.data" :href="subitem.data.hrefURL">
                        {{ subitem.label }}
                      </a>
                    </li>
                  </ul>
                </div>
              </span>
            </div>

            <div class="top-nav-more-menu" @click="handleShowMoreMenu"></div>
            <operation-container
              v-if="showOperationBtn && !showEditForm"
              :component-data="props.componentData"
              :show-edit-content-button="props.showEditContentButton"
              :show-edit-components-button="props.showEditComponentsButton"
              :show-delete-components-button="props.showDeleteComponentsButton"
              :show-insert-components-button="props.showInsertComponentsButton"
              :show-sort-components-button="props.showSortComponentsButton"
              @handle-show-edit-form="handleShowEditForm"
              @handle-change-components="handleChangeComponents"
              @handle-delete-components="handleDeleteComponents"
              @handle-insert-components="handleInsertComponents"
              @handle-sort-components="handleSortComponents"
            ></operation-container>
          </div>
        </div>
        <div class="top-nav-mobile">
          <div
            :class="{
              'top-nav-menu-container': !isDarkLogoStyle && !isBackTopFlag,
              'top-nav-menu-container-deep': isDarkLogoStyle,
              'top-nav-menu-container-deep-home': isBackTopFlag,
            }"
          >
            <div class="top-nav-menu-logo">
              <a :href="indexHrefUrl"
                ><img
                  :src="leftMobileLogoImageUrl || noUpload"
                  alt="Logo"
                  loading="lazy"
              /></a>
            </div>
            <div
              class="top-nav-menu-list-mask-layer"
              :class="{ show: showMobileMenuList }"
              @click="handleShowMoreMenu"
            ></div>
            <div
              class="top-nav-menu-list"
              :class="{ show: showMobileMenuList }"
            >
              <!-- [优化-2026-03-09] 菜单头部Logo + 关闭按钮 -->
              <!-- 回滚：删除此 div.menu-header，恢复 <span class="menu-close"> 到原位置 -->
              <div class="menu-header">
                <a :href="indexHrefUrl" class="menu-logo">
                  <img
                    :src="leftMobileLogoImageUrl || noUpload"
                    alt="Logo"
                    loading="lazy"
                  />
                </a>
                <span class="menu-close" @click="handleShowMoreMenu"></span>
              </div>
              <!-- [优化-2026-03-09] end -->
              <!-- [优化-2026-03-09] 功能区：搜索+登录 -->
              <!-- 回滚：删除此 div.menu-actions -->
              <div class="menu-actions">
                <a
                  class="action-search"
                  :href="handleSearchHref(configDataForm.searchLinkUrl)"
                >
                  <span class="action-icon"></span>
                  <span class="action-text">{{ configDataForm.searchTextTitle }}</span>
                </a>
                <a
                  class="action-login"
                  :href="configDataForm.loginLinkUrl"
                  target="_blank"
                >
                  <span class="action-icon"></span>
                  <span class="action-text">{{ configDataForm.loginTextTitle }}</span>
                </a>
              </div>
              <!-- [优化-2026-03-09] end -->
              <span
                v-for="item in mobileColumnList"
                :key="item.id"
                :class="{
                  active: item.id == activeIndex && item.showSubMenu,
                  'top-nav-menu-list-item': true,
                }"
              >
                <a
                  v-if="item.children && item.children.length > 0"
                  class="menu-item-text"
                  @click="handleToggleShowSubMenu(item)"
                >
                  {{ item.label }}
                </a>
                <a
                  v-else-if="item.data"
                  class="menu-item-text-single"
                  :href="item.data.hrefURL"
                >
                  {{ item.label }}
                </a>
                <div
                  v-if="item.children && item.children.length > 0"
                  class="sub-menu"
                >
                  <ul class="sub-nav">
                    <li
                      v-for="subitem in item.children"
                      :key="'su-el' + item.id + '-' + subitem.id"
                    >
                      <a v-if="subitem.data" :href="subitem.data.hrefURL">
                        {{ subitem.label }}
                      </a>
                    </li>
                  </ul>
                </div>
              </span>
            </div>

            <!-- [移动端优化-2026-03-09] 移除顶部重复的搜索和登录按钮，只保留菜单按钮 -->
            <!-- 回滚：恢复 <div class="mobile-search">...</div> -->
            <div class="top-nav-more-menu" @click="handleShowMoreMenu"></div>
            <!-- [移动端优化-2026-03-09] end -->
          </div>
        </div>
      </div>
      <div
        class="top-nav"
        :class="{
          'top-nav-deep': isDarkLogoStyle,
        }"
      ></div>
    </div>
    <el-drawer
      v-if="showEditForm"
      v-model="showEditForm"
      size="60%"
      :title="props.componentData.componentName"
    >
      <top-nav-edit-form
        v-if="showEditForm"
        v-model="configDataFormModel"
        :component-data="props.componentData"
        @handle-show-edit-form="handleShowEditForm"
        @handle-edit-components-content="handleEditComponentsContent"
      ></top-nav-edit-form>
    </el-drawer>
  </div>
</template>

<script setup>
// #region 引用
import { useSSRContext } from '@/ssr/use-context';
import useSSRInitialStateStore from '@/stores/ssr-state';
import TopNavEditForm from './TopNavEditFormTwoWithLeft.vue';
import OperationContainer from '../common/OperationContainer.vue';

// #endregion

// #region props/emit
/**
 * 属性
 */
const props = defineProps({
  showEditContentButton: {
    type: Boolean,
    default: true,
  },
  showEditComponentsButton: {
    type: Boolean,
    default: false,
  },
  showDeleteComponentsButton: {
    type: Boolean,
    default: false,
  },
  showInsertComponentsButton: {
    type: Boolean,
    default: false,
  },
  showSortComponentsButton: {
    type: Boolean,
    default: false,
  },
  componentData: {
    type: Object,
    default() {},
  },
});

/**
 * 方法
 */
const emits = defineEmits([
  'handle-show-edit-form',
  'handle-change-components',
  'handle-delete-components',
  'handle-insert-components',
  'handle-sort-components',
  'handle-edit-components-content',
  'update:modelValue',
]);

// #endregion

// #region 变量/常量

// 处理图片未上传的情况
// 预加载所有图片（构建时生成映射）
const images = import.meta.glob('@/assets/images/web/common/other/*.png', {
  eager: true,
  query: '?url',
});
// 直接获取目标图片 URL
const noUpload =
  images['/src/assets/images/web/common/other/no-upload.png']?.default;

// 操作显示按钮控制
const showOperationBtn = ref(false);
// 显示编辑表单
const showEditForm = ref(false);

// 创建变量设默认值
const configDataForm = computed(() => {
  return JSON.parse(props.componentData.configData);
});
// 表单数据
const configDataFormModel = ref({});
// 是否移动菜单列表样式
const showMobileMenuList = ref(false);

const previewId = ref(null);

const route = useRoute();
const ssrInitialState = useSSRInitialStateStore();

/**
 * 在服务端获取数据
 * 注意：子组件的 onServerPrefetch 与父组件并发执行，
 * 此时父组件可能还未设置 initialState.data.current，
 * 因此在 SSR 期间通过 useSSRContext 直接读取正在构建中的状态
 */
if (import.meta.env.SSR) {
  const ssrContext = useSSRContext();
  // 使用可选链避免访问 undefined
  previewId.value = ssrContext.initialState?.data?.current?.previewId;
} else {
  // 客户端从 initialState 读取数据
  previewId.value = ssrInitialState.data?.current?.previewId;
}

// 是否显示深色logo样式的菜单
const isDarkLogoStyle = computed(() => {
  // 默认显示浅色场景
  if (!route) {
    return false;
  }
  const routeName = [
    'website-home-preview',
    'website-website-home',
    'website-template-home',
    'website-preview-home',
  ]; // 首页默认显示深色场景
  return !routeName.includes(route.name);
});
// 返回顶部按钮显示
const isBackTopFlag = computed(() => {
  return ssrInitialState.backTopFlag;
});

// 左侧logo资源地址
const leftLogoImageUrl = computed(() => {
  return isDarkLogoStyle.value || ssrInitialState.backTopFlag
    ? configDataForm.value.leftDeepLogoImageFullUrl
    : configDataForm.value.leftLogoImageFullUrl;
});

const leftMobileLogoImageUrl = computed(() => {
  return configDataForm.value.leftLogoImageFullUrl;
});
// web栏目列表
const columnList = computed(() => {
  return configDataForm.value.columnList;
});

const curActiveIndex = ref(null);

// 默认选中key
const activeIndex = computed(() => {
  if (curActiveIndex.value) {
    return curActiveIndex.value;
  }

  if (configDataForm.value.activeIndex) {
    let id = configDataForm.value.activeIndex; // 没有子菜单的栏目id,就是选择当前栏目的id,有子菜单的就选择当前栏目下第一个子菜单的父级栏目id
    // 是点击选中下级菜单数据时，需要选中父级栏目id,而不是当前栏目的id,所以这里需要重新计算id值
    columnList.value.forEach((element) => {
      element.children.forEach((item) => {
        if (item.id === Number(configDataForm.value.activeIndex) && item.data) {
          id = item.data.parentId;
        }
      });
    });
    return `${id.toString()}`;
  }

  return columnList.value[0].id.toString();
});

// 首页链接
const indexHrefUrl = computed(() => {
  return columnList.value[0]?.data
    ? columnList.value[0]?.data?.hrefURL
    : columnList.value[0]?.hrefURL;
});

const mobileColumnList = computed(() => {
  return configDataForm.value.columnList.map((item) => {
    return {
      ...item,
      showSubMenu: item.id === Number(activeIndex.value),
    };
  });
});

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

/**
 * 处理搜索跳转链接
 */
const handleSearchHref = (searchLinkUrl) => {
  if (searchLinkUrl && searchLinkUrl.toLowerCase().startsWith('http')) {
    return searchLinkUrl;
  }
  if (previewId.value) {
    return `${searchLinkUrl}/${previewId.value}`;
  }
  return searchLinkUrl;
};

/**
 * 切换子菜单显示状态
 *
 * @param item 子菜单项对象
 */
const handleToggleShowSubMenu = (item) => {
  item.showSubMenu = !item.showSubMenu;
  curActiveIndex.value = item.id.toString();
  if (!item.showSubMenu) {
    curActiveIndex.value = null;
  }
};

/**
 * 显示或隐藏更多菜单。
 * [优化-2026-03-09] 添加关闭动画
 * 回滚：删除动画相关逻辑，恢复为简单切换
 */
const handleShowMoreMenu = () => {
  if (showMobileMenuList.value) {
    // 关闭时：先添加 hiding 类播放动画，结束后再隐藏
    const menuList = document.querySelector('.top-nav-menu-list.show');
    if (menuList) {
      menuList.classList.add('hiding');
      setTimeout(() => {
        showMobileMenuList.value = false;
        menuList.classList.remove('hiding');
      }, 250); // 动画时长
    } else {
      showMobileMenuList.value = false;
    }
  } else {
    showMobileMenuList.value = true;
  }
};
// [优化-2026-03-09] end

// 操作显不显示编辑内容按钮
/**
 * 显示
 */
const handleShowOperationBtn = (flag) => {
  showOperationBtn.value = flag;
};
/**
 * 显示编辑表单
 */
const handleShowEditForm = (flag) => {
  showEditForm.value = flag;
};
/**
 * 处理编辑表单内容
 */
const handleEditComponentsContent = (flag) => {
  // 待数据更新完成后才执行
  nextTick(() => {
    emits('update:modelValue', configDataFormModel.value);
    emits('handle-edit-components-content', true);
  });

  handleShowEditForm(flag);
};

/**
 * 改变组件
 */
const handleChangeComponents = () => {
  emits('handle-change-components', true);
};

/**
 * 删除组件
 */
const handleDeleteComponents = () => {
  emits('handle-delete-components', true);
};

/**
 * 插入组件
 */
const handleInsertComponents = () => {
  emits('handle-insert-components');
};
/**
 * 组件排序
 */
const handleSortComponents = (moveObj) => {
  emits('handle-sort-components', moveObj);
};

// #endregion
</script>
<style lang="scss">
.top-nav-container {
  position: relative;
  width: 100%;

  .top-nav.top-nav-fixed {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001; /* 需高于内容区组件的操作浮层(z-index:1000)，避免轮播图等覆盖导航栏导致悬停无法触发 */
  }

  .top-nav.top-nav-absolute {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1001; /* 需高于内容区组件的操作浮层(z-index:1000)，避免轮播图等覆盖导航栏导致悬停无法触发 */
  }
}
</style>

<style scoped lang="scss">
@import '@/styles/website/_variables.scss';

// ============================================
// 设计变量 - 统一视觉和交互规范
// ============================================
$nav-color-primary: #194294; // 主色调（深蓝）
$nav-color-secondary: #0c327e; // 次色调（更深蓝）
$nav-color-accent: #5cb8e8; // 强调色（亮青蓝）
$nav-color-highlight: #22cbf2; // 高亮色（鲜艳青）
$nav-color-text-light: #fff; // 浅色文字
$nav-color-text-dark: #373737; // 深色文字
$nav-color-hover-bg: #f6f8fa; // 悬停背景
$nav-color-hover-text: #2a5cb8; // 悬停文字（同色系亮蓝）

// 动画时长（统一规范）
$nav-duration-fast: 0.15s; // 快速交互
$nav-duration-normal: 0.25s; // 标准过渡
$nav-duration-slow: 0.4s; // 慢速过渡

// 动画曲线
$nav-ease-out: cubic-bezier(0, 0, 0.2, 1);
$nav-ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);

/* PC端样式 */
@include pc {
  // 隐藏移动端菜单
  .top-nav-mobile {
    display: none;
  }
  //显示桌面端菜单
  .top-nav-web {
    display: block;
  }
  .top-nav {
    display: flex;
    flex-direction: column;
    width: 100%;
    transition: all 0.3s;

    .top-nav-login-search {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 60px;
      font-family: SourceHanSansSC, sans-serif;
      font-size: 18px;
      img {
        height: 100%;
      }

      .search-link {
        position: absolute;
        top: 50%;
        right: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transform: translateY(-50%);

        .login {
          font-size: 18px;
          font-weight: 500;
          transition: all $nav-duration-fast;

          &:hover {
            opacity: 0.9;
          }

          // 分隔符
          &::after {
            margin-right: 30px;
            margin-left: 30px;
            content: '|';
            opacity: 0.5;
          }
        }

        .search {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: auto;
          height: 42px;
          padding-right: 16px;
          padding-left: 16px;
          font-weight: 500;
          line-height: 32px;
          white-space: nowrap;
          background: rgb(255 255 255 / 20%);
          backdrop-filter: blur(8px);
          border: 1px solid rgb(255 255 255 / 50%);
          border-radius: 21px;
          transition: all $nav-duration-normal $nav-ease-out;

          &:hover {
            background: rgb(255 255 255 / 30%);
            border-color: $nav-color-highlight;
            box-shadow: 0 0 0 3px rgba($nav-color-highlight, 0.2);
          }
        }

        .search::after {
          width: 20px;
          height: 20px;
          margin-left: 10px;
          color: #fff;
          content: '';
          background: url('image/search-icon.svg') no-repeat center center;
          background-size: cover;
        }
      }
    }
    .top-nav-menu-container-deep,
    .top-nav-menu-container-deep-home,
    .top-nav-menu-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: var(--nav-menu-height, 108px);
      background: url('image/head_bg.png') no-repeat center center;
      background-size: cover;
      transition:
        height $nav-duration-normal $nav-ease-out,
        background $nav-duration-slow,
        box-shadow $nav-duration-normal;

      .top-nav-menu-logo {
        width: 460px;
        height: 80px;
        margin-left: 80px;

        a {
          display: inline-block;
          height: 100%;
        }

        img {
          height: 100%;
          object-fit: cover;
          transition: transform $nav-duration-normal $nav-ease-out;
        }

        &:hover img {
          transform: scale(1.03);
        }
      }
      //导航菜单
      .top-nav-menu-list {
        display: flex;
        flex-wrap: nowrap;
        margin-right: 80px;
        .top-nav-menu-list-item {
          position: relative;
          display: flex;
          flex: auto;
          align-content: center;
          align-items: center;
          padding-bottom: 10px;
          margin: 18px 8px;
          font-family: '微软雅黑 Regular', '微软雅黑', sans-serif;
          font-size: 22px;
          font-style: normal;
          letter-spacing: 1px;
          cursor: pointer;

          a {
            display: inline-block;
            color: $nav-color-text-light;
            transition:
              color $nav-duration-fast $nav-ease-out,
              transform $nav-duration-fast $nav-ease-out;
          }

          // 悬停效果增强 - 轻微上移 + 变色
          &:hover a {
            color: $nav-color-accent;
            transform: translateY(-2px);
          }

          // 下级菜单样式 - 增强动画效果
          .sub-menu {
            position: absolute;
            top: 100%; // 紧贴主菜单底部
            left: 0; // 左对齐（遵循对齐原则）
            z-index: 2;
            min-width: 140px;
            padding-top: 6px; // 视觉间距
            margin-top: -6px; // 悬停区域连通（向上延伸）
            visibility: hidden;
            background-color: $nav-color-text-light;
            border-radius: 0 0 $website-radius-sm $website-radius-sm;
            box-shadow: 0 8px 24px rgb(0 0 0 / 12%);
            opacity: 0;
            transition:
              opacity $nav-duration-fast $nav-ease-out,
              transform $nav-duration-fast $nav-ease-out,
              visibility $nav-duration-fast;
            transform: translateY(-8px);

            // 顶部装饰条（渐变效果）
            &::before {
              position: absolute;
              top: 0;
              right: 0;
              left: 0;
              height: 4px;
              content: '';
              background: linear-gradient(
                90deg,
                $nav-color-primary,
                $nav-color-accent
              );
              border-radius: 2px 2px 0 0;
            }

            ul {
              z-index: 10;
              width: 100%;
              padding: 8px 0;

              li {
                z-index: 1;

                a {
                  display: block;
                  padding: 8px 20px;
                  overflow: hidden;
                  font-size: 16px;
                  line-height: 1.5;
                  color: $nav-color-text-dark;
                  text-align: left;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  transition:
                    color $nav-duration-fast $nav-ease-out,
                    background-color $nav-duration-fast $nav-ease-out,
                    padding-left $nav-duration-fast $nav-ease-out;
                }

                &:hover a {
                  padding-left: 24px;
                  color: $nav-color-hover-text;
                  background-color: $nav-color-hover-bg;
                }
              }
            }
          }
        }

        // 激活状态 - 渐变边框效果
        .top-nav-menu-list-item.active {
          position: relative;

          &::after {
            position: absolute;
            right: 0;
            bottom: 0;
            left: 0;
            height: 4px;
            content: '';
            background: linear-gradient(
              90deg,
              $nav-color-primary,
              $nav-color-highlight
            );
            border-radius: 2px;
          }

          a {
            color: $nav-color-highlight;
          }
        }

        // 悬停显示子菜单 - 修复动画
        .top-nav-menu-list-item:hover {
          .sub-menu {
            visibility: visible;
            opacity: 1;
            transform: translateY(0);
          }
        }
      }
    }

    // 滚动后样式（deep 和 deep-home 合并优化）
    .top-nav-menu-container-deep,
    .top-nav-menu-container-deep-home {
      height: 88px;
      background: $nav-color-text-light;
      box-shadow: 0 2px 18px 0 rgb(0 0 0 / 5%);

      .top-nav-menu-logo {
        width: 400px;
        height: 60px;
        margin-right: 0;

        a {
          display: inline-block;
          height: 100%;
        }

        img {
          height: 100%;
          object-fit: contain;
          transition: transform $nav-duration-fast $nav-ease-out;
        }

        &:hover img {
          transform: scale(1.03);
        }
      }

      .top-nav-menu-list {
        .top-nav-menu-list-item {
          a {
            color: $nav-color-text-dark;
            transition: color $nav-duration-fast $nav-ease-out;
          }

          &:hover a {
            color: $nav-color-hover-text;
          }

          &.active a {
            color: $nav-color-hover-text;
          }
        }
      }
    }

    .top-nav-more-menu {
      display: none;
    }
  }

  .top-nav-deep {
    height: 152px;
  }
}

/* 移动端样式 */
@include mobile {
  // 显示移动端菜单
  .top-nav-mobile {
    display: block;
  }
  //隐藏桌面端菜单
  .top-nav-web {
    display: none;
  }
  .top-nav {
    width: 100% !important;
    min-width: auto !important;
    transition: all 0.3s;

    .top-nav-login-search {
      display: none;
    }

    .top-nav-menu-container-deep,
    .top-nav-menu-container-deep-home,
    .top-nav-menu-container {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      height: 16vw;
      margin: 0;
      background: url('image/head_bg.png') no-repeat center center;
      background-size: cover;
      transition: all $nav-duration-slow $nav-ease-in-out;

      .top-nav-menu-logo {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-top: 2vw;
        img {
          height: 8vw;
          margin-left: 2vw;
          object-fit: cover;
        }
      }

      .top-nav-menu-list-mask-layer {
        display: none;
        width: 100%;
        height: 100vh;
        background-color: #666;
        opacity: 0.6;
      }

      .top-nav-menu-list-mask-layer.show {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9998;
        display: block;
        // [优化-2026-03-09] 遮罩层渐入动画
        // 回滚：删除 animation 和 @keyframes fadeInMask
        animation: fadeInMask $nav-duration-fast $nav-ease-out;
        // [优化-2026-03-09] end
      }

      .top-nav-menu-list {
        display: none;
      }

      .top-nav-menu-list.show {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9999;
        display: flex;
        flex-direction: column;
        // [优化-2026-03-09] 全屏展示
        // 回滚：改为 width: 50vw;
        width: 100vw;
        // [优化-2026-03-09] end
        height: 100vh;
        overflow-y: auto;
        // [移动端优化-2026-03-09] 毛玻璃效果
        // 回滚：改为 background-color: $nav-color-primary; 删除 backdrop-filter
        background-color: rgb(25 66 148 / 92%);
        backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
        // [移动端优化-2026-03-09] end
        // [优化-2026-03-09] 动画时长调整 - 更平缓
        // 回滚：改为 animation: slideInFromRight $nav-duration-fast $nav-ease-out;
        animation: slideInFromRight 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        // [优化-2026-03-09] end

        // [优化-2026-03-09] 关闭动画
        // 回滚：删除此样式块
        &.hiding {
          animation: slideOutToRight 0.25s cubic-bezier(0.4, 0, 1, 1);
        }
        // [优化-2026-03-09] end

        // [优化-2026-03-09] 菜单头部Logo - 固定在顶部
        // 回滚：删除此样式块
        .menu-header {
          position: sticky;
          top: 0;
          z-index: 10;
          display: flex;
          flex-shrink: 0;
          align-items: center;
          justify-content: space-between;
          height: 16vw;
          padding: 2vw 4vw;
          // [移动端优化-2026-03-09] 毛玻璃效果
          background-color: rgb(25 66 148 / 95%);
          backdrop-filter: blur(20px);
          backdrop-filter: blur(20px);
          // [移动端优化-2026-03-09] end

          .menu-logo {
            display: flex;
            align-items: center;

            img {
              height: 8vw;
              object-fit: contain;
            }
          }

          // [优化-2026-03-09] 关闭按钮移入header
          // 回滚：将 .menu-close 移出 .menu-header，恢复 position: absolute
          .menu-close {
            position: relative;
            top: auto;
            right: auto;
            display: flex;
            width: 8vw;
            height: 8vw;
            cursor: pointer;
            background: url('image/nav-close.png') no-repeat center center;
            background-color: rgb(255 255 255 / 10%);
            background-size: 60%;
            border-radius: 50%;
            transition:
              opacity $nav-duration-fast,
              transform $nav-duration-normal $nav-ease-out,
              background-color $nav-duration-fast;

            &:hover {
              background-color: rgb(255 255 255 / 20%);
              transform: rotate(90deg);
            }

            &:active {
              opacity: 0.6;
            }
          }
          // [优化-2026-03-09] end
        }
        // [优化-2026-03-09] end

        // [移动端优化-2026-03-09] 功能区：搜索框占满 + 登录固定宽度
        // 回滚：删除此样式块
        .menu-actions {
          display: flex;
          flex-shrink: 0;
          gap: 3vw;
          align-items: center;
          height: 14vw;
          padding: 0 4vw;
          background-color: rgb(0 0 0 / 15%);

          a {
            display: flex;
            gap: 2vw;
            align-items: center;
            height: 10vw;
            font-size: 4vw;
            font-weight: 500;
            color: $nav-color-text-light;
            border-radius: 2vw;
            transition:
              opacity $nav-duration-fast,
              transform $nav-duration-fast;

            &:active {
              opacity: 0.8;
              transform: scale(0.98);
            }

            .action-icon {
              width: 5vw;
              height: 5vw;
              background-repeat: no-repeat;
              background-position: center;
              background-size: contain;
            }
          }

          .action-search {
            flex: 1;
            padding: 0 3vw;
            background-color: rgb(255 255 255 / 10%);

            .action-icon {
              background-image: url('image/search-icon.svg');
            }

            .action-text {
              color: rgb(255 255 255 / 70%);
            }
          }

          .action-login {
            flex-shrink: 0;
            justify-content: center;
            width: 22vw;
            background-color: rgb(255 255 255 / 15%);

            .action-icon {
              background-image: url('image/user-icon.svg');
            }
          }
        }
        // [移动端优化-2026-03-09] end

        .top-nav-menu-list-item {
          position: relative;
          display: flex;
          flex-direction: column;
          // [优化-2026-03-09] 左对齐
          // 回滚：改为 align-items: center;
          align-items: flex-start;
          padding-left: 4vw;
          // [优化-2026-03-09] end
          font-size: 4.5vw;
          // [移动端优化-2026-03-09] 减少边框 - 更淡的分隔线
          // 回滚：改为 border-bottom: 0.25vw solid $nav-color-secondary;
          border-bottom: 1px solid rgb(255 255 255 / 6%);
          // [移动端优化-2026-03-09] end

          .menu-item-text-single,
          .menu-item-text {
            position: relative;
            display: flex;
            // [移动端优化-2026-03-09] 菜单项高度 + 整行可点击
            // 回滚：改为 align-items: center; height: 14vw; width: auto;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 16vw;
            padding-right: 4vw;
            // [移动端优化-2026-03-09] end
            font-weight: 700;
            color: $nav-color-text-light;
            cursor: pointer;
            // [移动端优化-2026-03-09] 触摸反馈：缩放 + 背景
            // 回滚：删除 transform 和 background-color
            transition:
              background-color $nav-duration-fast,
              transform $nav-duration-fast;

            &:active {
              background-color: rgb(255 255 255 / 8%);
              transform: scale(0.98);
            }
            // [移动端优化-2026-03-09] end
          }

          .menu-item-text::after {
            // [移动端优化-2026-03-09] 箭头放到最右侧
            // 回滚：添加 left: 20px; display: inline-block;
            position: absolute;
            right: 4vw;
            // [移动端优化-2026-03-09] end
            display: flex;
            width: 8px;
            height: 8px;
            content: '';
            border-right: 2px solid $nav-color-text-light;
            border-bottom: 2px solid $nav-color-text-light;
            transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            transform: rotate(45deg);
          }

          // 下级菜单样式 - 展开动画
          .sub-menu {
            display: flex;
            // [优化-2026-03-09] 左对齐 + 子菜单缩进
            // 回滚：改为 align-items: center; justify-content: center; width: 50vw; padding: 0;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;
            // [优化-2026-03-09] end
            max-height: 0;
            padding-left: 4vw;
            overflow: hidden;
            color: $nav-color-text-light;
            background-color: rgb(0 0 0 / 10%);
            // [优化-2026-03-09] 优化展开动画 - 更平缓，避免抖动
            // 回滚：改为 transition: max-height $nav-duration-normal $nav-ease-out;
            transition: max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1);
            // [优化-2026-03-09] end

            ul {
              // [优化-2026-03-09] 宽度调整
              // 回滚：改为 width: 50vw;
              width: 100%;
              // [优化-2026-03-09] end
              // [移动端优化-2026-03-09] 减少子菜单边框
              // 回滚：改为 border-bottom: 1px solid rgba(255, 255, 255, 0.1);
              li:not(:last-of-type) {
                border-bottom: 1px solid rgb(255 255 255 / 5%);
              }
              // [移动端优化-2026-03-09] end

              li {
                display: flex;
                // [优化-2026-03-09] 左对齐
                // 回滚：改为 align-items: center; justify-content: center; height: 18vw; margin: 0 8vw;
                align-items: center;
                justify-content: flex-start;
                height: 12vw;
                padding-left: 2vw;
                margin: 0;
                // [优化-2026-03-09] end

                // [优化-2026-03-09] 子菜单项点击反馈 + 字号调整
                // 回滚：删除 a 样式，改为原来的 li a 样式
                a {
                  font-size: 3.5vw;
                  transition: opacity $nav-duration-fast;

                  &:active {
                    opacity: 0.7;
                  }
                }
                // [优化-2026-03-09] end
              }
            }
          }
        }

        .top-nav-menu-list-item.active {
          // [移动端优化-2026-03-09] 激活状态：仅背景高亮（移除左侧条）
          // 回滚：删除 ::before，改为 border-left 添加左侧条

          // 左侧强调条（可选，暂时保留但更细更淡）
          &::before {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            width: 3px;
            content: '';
            background: $nav-color-highlight;
            opacity: 0.8;
          }

          // 背景高亮
          background-color: rgb(34 203 242 / 10%);
          // [移动端优化-2026-03-09] end

          .menu-item-text {
            color: $nav-color-highlight;
          }

          .sub-menu {
            max-height: 300px;
          }

          .menu-item-text::after {
            transform: rotate(-135deg);
          }
        }
      }

      // [移动端优化-2026-03-09] 删除 .mobile-search 样式（移除顶部重复的搜索/登录按钮）
      // 回滚：恢复此样式块
      // .mobile-search { ... }
      // [移动端优化-2026-03-09] end

      // [移动端优化-2026-03-09] .top-nav-more-menu 直接定位到右侧
      // 回滚：恢复 margin-left: auto; 删除 position: absolute; right: 20px; top: 50%; transform: translateY(-50%);
      .top-nav-more-menu {
        position: absolute;
        top: 50%;
        right: 20px;
        display: flex;
        width: 6vw;
        height: 6vw;
        cursor: pointer;
        background: url('image/top-nav-menu-white.png') no-repeat center center;
        background-size: 100%;
        transition:
          opacity $nav-duration-fast,
          transform $nav-duration-normal $nav-ease-out;
        transform: translateY(-50%);

        &:hover {
          transform: translateY(-50%) scale(1.1);
        }

        &:active {
          opacity: 0.6;
        }
      }
      // [移动端优化-2026-03-09] end
    }
    // [移动端优化-2026-03-09] .top-nav-menu-container 闭合

    // 滚动后样式合并
    .top-nav-menu-container-deep,
    .top-nav-menu-container-deep-home {
      background: $nav-color-primary;
    }
  }

  .top-nav-deep {
    height: 16vw;
  }
}
</style>
